/**
 * Company branding constants used in exported PDF/Excel reports.
 * Values can be overridden at runtime via the localStorage keys read in exportReports.
 */
export const APP_NAME = 'EdgeFinances';

export const COMPANY_LEGAL_NAME = 'EDGE FINANCES';

/** Shown on the line below the company name (office area). */
export const COMPANY_LOCATION = 'Head Office';

export const COMPANY_REPORT_TAGLINE = 'Finance & Accounting Management Report';

export const COMPANY_DEFAULT_ADDRESS = 'Hyderabad, Telangana, India';
export const COMPANY_DEFAULT_PHONE = '+91 90000 00000';
export const COMPANY_DEFAULT_EMAIL = 'support@edgefinances.app';
export const COMPANY_DEFAULT_WEBSITE = 'www.edgefinances.app';
